// Admin / admin / staff / shareholder are served from the same origin and therefore
// share one localStorage. They also use identical key names ("cohToken",
// "username", ...), so signing into one app silently authenticated the others.
// Namespace every key for this app; call sites keep using localStorage as-is.
const PREFIX = 'admin:';

const native = window.localStorage;
const scopedKey = (key) => PREFIX + key;

const scoped = {
  get length() {
    return Object.keys(native).filter((k) => k.startsWith(PREFIX)).length;
  },
  key(index) {
    const keys = Object.keys(native).filter((k) => k.startsWith(PREFIX));
    const k = keys[index];
    return k === undefined ? null : k.slice(PREFIX.length);
  },
  getItem(key) {
    return native.getItem(scopedKey(key));
  },
  setItem(key, value) {
    native.setItem(scopedKey(key), value);
  },
  removeItem(key) {
    native.removeItem(scopedKey(key));
  },
  clear() {
    Object.keys(native)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => native.removeItem(k));
  },
};

try {
  Object.defineProperty(window, 'localStorage', {
    configurable: true,
    get: () => scoped,
  });
} catch (e) {
  /* noop - storage stays shared if the override is rejected */
}
